<div *ngIf="showOrientationModal" class="orientation">
  <svg-icon class="cross-icon" role="button" aria-label="Close Dialog"
    aeroTooltip="{{'orientation.orientationCancel' | transloco}}" (click)="closeDialog()" key="times">
  </svg-icon>
  <span class="orientation-heading" transloco="orientation.orientationHeading">Carousel Orientation</span>
  <div class="orientation-widget-position">
    <div class="orientation-widget">
      <div class="landscape-orientation-width" (click)="uploadImage('LANDSCAPE')">
        <img class="bulb-landscape-orientation" [src]="'resources/images/bulb_landscape_orientation.svg'" alt="" />
      </div>
      <div class="orientation-text landscape-text" transloco="orientation.orientationLandscape">Landscape</div>
    </div>
    <div class="orientation-widget">
      <div class="portrait-orientation-width" (click)="uploadImage('PORTRAIT')">
        <img class="bulb-portrait-orientation" [src]="'resources/images/bulb_portrait_orientation.svg'" alt="" />
      </div>
      <div class="orientation-text portrait-text" transloco="orientation.orientationPortrait">Portrait</div>
    </div>
    <div class="orientation-widget">
      <div class="square-orientation-width" (click)="uploadImage('SQUARE')">
        <img class="bulb-square-orientation" [src]="'resources/images/bulb_square_orientation.svg'" alt="" />
      </div>
      <div class="orientation-text square-text" transloco="orientation.orientationSquare">Square</div>
    </div>
    <div class="orientation-widget">
      <div class="freeform-orientation-width" (click)="uploadImage('FREEFORM')">
        <img class="bulb-freeform-orientation" [src]="'resources/images/bulb_unconstrained_orientation.svg'" alt="" />
      </div>
      <div class="orientation-text freeform-text" transloco="orientation.orientationFreeform">Freeform</div>
    </div>
  </div>
</div>
<div *ngIf="!showOrientationModal">
<bulb-image-cropper *ngIf="showImageCropper" [imageAsset]="image"
                    [hasMoreImages]="hasMoreImages"
                    [type]="type"
                    (saveCroppedImage)="cropImage($event)"
                    (cancelCrop)="deleteImage()"
                    [enableRotate]="true"
                    #imageCropperComponent></bulb-image-cropper>
</div>
